// Pemeriksaan Pra-masuk COVID-19
export const register = Vue => {
  Vue.prototype.$language = language();
  Vue.prototype.$getLanguage = getLanguage;
  Vue.prototype.$setLanguage = setLanguage;
};

const LANGUAGE_DATA = "COVID-LANGUAGE";
const language = () => {
  let lang = localStorage.getItem(LANGUAGE_DATA);
  if (lang === "en") {
    return enData;
  } else if (lang === "my") {
    return myData;
  }

  return enData;
};

const getLanguage = () => {
  if (typeof localStorage !== "undefined") {
    // localStorage.setItem(AUTH_TOKEN, token);
    let data = localStorage.getItem(LANGUAGE_DATA);
    return data;
  }
  return null;
};

const setLanguage = data => {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(LANGUAGE_DATA, data);
  }
  return null;
};

const enData = {
  loginLabel: "COVID-19 Pre-entry Screening",
  labelICPassport: "IC/Passport Number",
  messageICPassport: "IC example: '93XXXX07XXXX' without any dash",
  loginButton: "Login",
  fullName: "Full Name",
  contactNo: "Contact No",
  email: "Email",
  companyAddress: "Company & Address",
  homeAddress: "Home Address",
  register: "Register",
  back: "Back",
  consent: `I hereby agree that my personal data will be collected and processed in accordance to the Malaysia’s 
  Personal Data Protection Act 2010 and the Prevention and Control of Infectious Diseases Act 1988 as further 
  set out in the Privacy Statement which can be accessed`,
  here: "here.",
  consentAgree: "I consent to the collection and processing of my data for the above purpose",
  yes: "Yes",
  no: "No",
  generalInformation: "General Information",
  preEntry: "Pre-Entry Screening",
  opuAsset: "OPU/Assets",
  location: "Location",
  entryDate: "Entry Date",
  meetingHost: "Meeting Host (Name)",
  meetingVenue: "Meeting Venue",
  next: "Next",
  pleaseIfMeeting: "Please fill in if you are joining any meeting:",
  question1: "Question 1",
  question2: "Question 2",
  question3: "Question 3",
  question4: "Question 4",
  question1Details: "Have you travelled to / resided in foreign country within 14 days ?",
  question4Details: "Do you have any of the following symptoms?",
  question3Details: `Have you attended an event associated with known 
  COVID-19 outbreak in the last 14 days e.g. religious gathering, wedding receptions etc?`,
  question2Details: `Have you had contact with any SUSPECTED or CONFIRMED COVID-19 case in Malaysia or any other country in the past 14 days? `,
  fever: "Fever",
  cough: "Cough",
  soreThroat: "Sore Throat",
  breathingDifficulty: "Breathing Difficulty",
  newForm: "New Form",
  searchForm: "Search Form",
  administrator: "Administrator",
  myAccount: "My Account",
  signOut: "Sign Out",
  submit: "Submit",
  previous: "Previous",
  trackingNumber: "Tracking Number",
  applicantName: "Applicant Name",
  status: "Status",
  action: "Action",
  page: "Page",
  of: "of",
  records: "records",
  exportExcel: "Export to Excel",
  searchIc: "Search Via IC/Passport",
  noData: "No Data Found",
  confirm: "Confirm",
  close: "Close",
  resetSearch: "Reset Search",
  healthScreening: "Health Screening",
  approveRejectBy: "Rejected By",
  approveRejectDate: "Rejected Date",
  bodyTemperature: "Body Temperature (Celcius)",
  pleaseBodyTemperature: "Please provide body Temperature",
  approve: "Enter Body Temperature (Optional)",
  reject: "Reject",
  profileDetails: "Profile Details",
  changePassword: "Change Password",
  oldPassword: "Old Password",
  newPassword: "New Password",
  cNewPassword: "Confirm New Password",
  save: "Save",
  fromDate: "From Date",
  toDate: "To Date",
  headerSubmit: "Success!",
  messageSubmit: "Successfully submit COVID-19 Pre-Entry Screening form",
  headerApprove: "Record Approved",
  messageApprove: "Record has been approved",
  headerReject: "Record Rejected",
  messageReject: "Record has been rejected",
  newCovidForm: "PRE-ENTRY SCREENING TO PETRONAS FACILITIES FOR COVID-19 PANDEMIC CONTROL",
  searchCovidForm: "Search Covid 19 Form",
  approvedButHasYes: "Approved But Answer 'Yes'",
  viewForm: "View Form",
  remarks: "Remarks",
  petronasStaff: "PETRONAS Staff",
  contractor: "Contractor",
  visitor: "Visitor",
  staffId: "PETRONAS Staff ID",
  describeType: "Select the best to describe you before entering PETRONAS facilities:",
  enterStaffId: "Enter Your Staff ID (Only for PETRONAS Staff)",
  newQuestion1: "I do not have any fever*, cough, sore throat or breathing difficulty.",
  newQuestion2: `I do not have any close contact with positive/suspected (PUI) COVID-19 case for the past 14 days.`,
  newQuestion3: "I have not travelled to any country outside Malaysia for the past 14 days.",
  feverIndicated: "*fever is indicated as temperature of 37.5 Celsius and above as per definition by Ministry of Health, Malaysia",
  agreeSubmit: "Agree & Submit",
  herebyAgree: "I hereby declare that:",
  declareSubmit: "Your health declaration is successfully submitted",
  notApproveHeader: "Unsuccessful",
  notApproveMessage: `You are not fulfilling the health screening requirement 
    and not allowed to enter PETRONAS facilities. Please contact your HSE Focal for more info.`,
  tenant: "Tenant",
  tenantName: "Tenant Company Name",
  bodyTemperatureReadingDate: "Body Temperature Reading Date",
  bodyTemperatureReadingBy: "Body Temperature Reading By",
  supportingDocument: `Kindly attach your COVID-19 Test Report if Indicated or Required by PETRONAS focal person or your host`,
  numOfAttached: "File(s) Attached",
  uploadDocument: "Upload COVID-19 Test Report",
};

const myData = {
  loginLabel: "Pemeriksaan Pra-masuk COVID-19",
  labelICPassport: "IC/Nombor Passport",
  messageICPassport: "Contoh IC: '93XXXX07XXXX' tanpa -",
  loginButton: "Log Masuk",
  fullName: "Nama Penuh",
  contactNo: "Nombor Telefon",
  email: "Emel",
  companyAddress: "Syarikat & Alamat Syarikat",
  homeAddress: "Alamat Rumah",
  register: "Daftar",
  back: "Kembali",
  consent: `Saya dengan ini bersetuju bahawa data peribadi saya akan dikumpul dan diproses menurut 
  Akta Perlindungan data peribadi Malaysia 2010 dan Akta 1988 Pencegahan dan Pengawalan Penyakit 
  Berjangkit seperti yang dinyatakan dalam penyata privasi yang boleh diakses`,
  here: "di sini",
  consentAgree: "Saya bersetuju untuk pengumpulan dan pemprosesan data saya untuk tujuan di atas",
  yes: "Ya",
  no: "Tidak",
  generalInformation: "Maklumat Am",
  preEntry: "Pemeriksaan Pra-masuk",
  opuAsset: "Syarikat PETRONAS/Aset PETRONAS",
  location: "Lokasi",
  entryDate: "Tarikh Kemasukan",
  meetingHost: "Hos Mesyuarat (Nama)",
  meetingVenue: "Lokasi Mesyuarat",
  next: "Seterusnya",
  pleaseIfMeeting: "Isi sekiranya anda menyertai mana-mana mesyuarat:",
  question1: "Soalan 1",
  question2: "Soalan 2",
  question3: "Soalan 3",
  question4: "Soalan 4",
  question1Details: "Adakah anda pernah melancong ke / menetap di negara asing dalam masa 14 hari?",
  question4Details: "Adakah anda mempunyai simptom berikut?",
  question3Details: `Pernahkah anda menghadiri acara yang berkaitan 
    dengan wabak COVID-19 yang diketahui dalam 14 hari terakhir misalnya majlis agama, majlis perkahwinan dll?`,
  question2Details: `Adakah anda pernah berhubung dengan mana-mana pesakit 
    kes COVID-19 yang BERKEMUNGKINAN atau DISAHKAN di Malaysia atau negara lain dalam 14 hari yang lalu?`,
  fever: "Demam",
  cough: "Batuk",
  soreThroat: "Sakit Tekak",
  breathingDifficulty: "Kesukaran Bernafas",
  newForm: "Borang Baru",
  searchForm: "Cari Borang",
  administrator: "Pentadbir",
  myAccount: "Akaun Saya",
  signOut: "Log Keluar",
  submit: "Hantar",
  previous: "Sebelumnya",
  trackingNumber: "Nombor Pengesanan",
  applicantName: "Nama Pemohon",
  status: "Status",
  action: "Tindakan",
  page: "Halaman",
  of: "dari",
  records: "rekod",
  exportExcel: "Eksport ke Excel",
  searchIc: "Carian Guna IC/Passport",
  noData: "Tiada Data Dijumpai",
  confirm: "Sahkan",
  close: "Tutup",
  resetSearch: "Tetapkan Semula Pencarian",
  healthScreening: "Pemeriksaan Kesihatan",
  approveRejectBy: "Ditolak Oleh",
  approveRejectDate: "Tarikh Ditolak",
  bodyTemperature: "Suhu Badan (Celcius)",
  pleaseBodyTemperature: "Sila kemukakan Suhu Badan",
  approve: "Masukkan Suhu Badan (Tidak Wajib)",
  reject: "Tolak",
  profileDetails: "Maklumat Profil",
  changePassword: "Tukar Kata Laluan",
  save: "Simpan",
  oldPassword: "Kata Laluan Lama",
  newPassword: "Kata Laluan Baharu",
  cNewPassword: "Ulang Kata Laluan Baharu",
  fromDate: "Dari Tarikh",
  toDate: "Ke Tarikh",
  headerSubmit: "Berjaya!",
  messageSubmit: "Berjaya menghantar borang Pemeriksaan Pra-Kemasukan COVID-19",
  headerApprove: "Rekod Diluluskan",
  messageApprove: "Rekod Berjaya Diluluskan",
  headerReject: "Rekod Ditolak",
  messageReject: "Rekod telah ditolak",
  newCovidForm: "Borang Covid 19 Baru",
  searchCovidForm: "Carian Borang Covid 19",
  viewForm: "Lihat Borang",
  approvedButHasYes: "Lulus Tetapi Jawapan 'Ya'",
  remarks: "Sebab Ditolak",
  petronasStaff: "Kakitangan PETRONAS",
  contractor: "Kontraktor",
  visitor: "Pelawat",
  staffId: "ID Kakitangan PETRONAS",
  describeType: "Pilih kenyataan yang paling sesuai untuk diri anda sebelum memasuki fasiliti PETRONAS:",
  enterStaffId: "Masukkan ID Kakitangan anda (Hanya bagi kakitangan PETRONAS)",
  newQuestion1: "Saya tidak mempunyai simtom demam*, batuk, sakit tekak atau masalah pernafasan.",
  newQuestion2: `Saya tidak berhubung rapat dengan seseorang yang positif atau disyaki positif (PUI) COVID-19 dalam tempoh 14 hari yang lepas.`,
  newQuestion3: "Saya tidak berkunjung ke luar negara dalam tempoh 14 hari yang lepas.",
  feverIndicated: "*Demam adalah suhu badan 37.5 Celsius dan ke atas mengikut definisi Kementerian Kesihatan Malaysia",
  agreeSubmit: "Setuju & Hantar",
  herebyAgree: "Saya dengan ini mengakui bahawa:",
  declareSubmit: "Anda telah berjaya mengemukakan pengisytiharan kesihatan",
  notApproveHeader: "Tidak Berjaya",
  notApproveMessage: `Anda tidak memenuhi syarat pra-pemeriksaan kesihatan dan 
  tidak dibenarkan untuk memasuki fasiliti PETRONAS. Sila hubungi Fokal HSE anda untuk maklumat lanjut.`,
  tenant: "Penyewa",
  tenantName: "Nama Syarikat Penyewa",
  bodyTemperatureReadingDate: "Tarikh Bacaan Suhu Badan",
  bodyTemperatureReadingBy: "Bacaan Suhu Badan Oleh",
  supportingDocument: `Sila lampirkan Laporan Ujian Saringan Covid-19 anda sekiranya diarahkan oleh fokal PETRONAS atau hos anda`,
  numOfAttached: "Fail Dilampirkan",
  uploadDocument: "Lampirkan Laporan Ujian Saringan",
};
